import { render } from "./TourDescription.vue?vue&type=template&id=b3a349e8"
import script from "./TourDescription.vue?vue&type=script&lang=js"
export * from "./TourDescription.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__